<!-- 开户公司管理-->
<template>
  <div>
        <ctrl-box class="ctrl-box" ::data="{}">
            <template>
                <div class="xgroup">
                    <el-link :underline="false" @click="showQuery = !showQuery">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-search" font-size="27px;"/>
                            <span class="txt" >{{msg('搜索')}}</span>      
                        </div>                
                    </el-link>
                    <el-link :underline="false" @click="doAdd()" v-if="hasPermission('company:add')">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-tianjia" font-size="27px;"/>
                            <span class="txt">{{msg('添加')}}</span>
                        </div>            
                    </el-link>
                    <el-link :underline="false" @click="doEdit()" v-if="hasPermission('company:edit')">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-bianji" font-size="27px;"/>
                            <span class="txt">{{msg('编辑')}}</span>
                        </div>            
                    </el-link>
                    <el-link :underline="false" @click="doDelete()" v-if="hasPermission('company:delete')">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-shanchu1" font-size="27px;"/>
                            <span class="txt">{{msg('删除')}}</span>      
                        </div>
                    </el-link>
                </div>
            </template>
        </ctrl-box>
 
        <!--查询区域-->
        <transition name="el-zoom-in-top">
            <query-box :query="query" v-show="showQuery" labelWidth="80px">
                <template v-slot:default="scope">
                    <el-form-item :label="msg('公司名')">
                        <el-input v-model="scope.query.name" ></el-input>
                    </el-form-item>
                    <el-form-item :label="msg('日期')">
                        <el-date-picker  v-model="scope.query.Date" type="daterange"  :range-separator="msg('至')" 
                            value-format="yyyy-MM-dd"
                            end-placeholder=""
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-row>
                        <el-button type="primary" icon="el-icon-search" @click="list" size="mini">{{msg('搜索')}}</el-button>
                        <el-button icon="el-icon-refresh" size="mini" @click="reset" >{{msg('重置')}}</el-button>
                    </el-row>
                </template>
            </query-box>
        </transition>

        <div class="table-wrap">
            <vxe-grid ref="dataTable" :height="docHeight" 
                export-config
                resizable border="full"
                show-overflow highlight-hover-row
                highlight-current-row highlight-hover-column highlight-current-column
                :data="companys"
                :columns="columns"
                @cell-click="checkRow"
            ></vxe-grid>

            <pagenator @page-change="handlerPageChange" :query="query" >
            </pagenator>
        </div>

        
        <el-dialog :title="dgTitle" :close-on-click-modal="false" @opened="openEditDg"
            :visible.sync="dgVisible" width="600px"
            :fullscreen="isMinScreen">
                <edit :company="curr" ref="editRef" @close-dg="closeEditDialog" />
        </el-dialog>
    </div>  
</template>
<script>

import Pagenator from "../../components/Pagination.vue";
import CtrlBox from "../../components/CtrlBox.vue";
import QueryBox from "../../components/QueryBox.vue";
import Edit from "./CompanyEdit.vue";

export default {
    name: 'company',
    components:{
        Pagenator:Pagenator,
        CtrlBox: CtrlBox,
        QueryBox: QueryBox,
        Edit: Edit,
    },
    created(){
        this.loginUser  = JSON.parse(localStorage.getItem("user"));
    },
    mounted:function(){
        this.list();
    },
    data(){
        return {
            query:{
                length: 10,
                start: 0,
                pageIndex:1,
                pageTotal: 0,
            },
            loginUser:null,
            showQuery: false,
            columns: [
                {type: 'checkbox', minWidth: 40},
                {field: 'id', title: this.msg('ID'), minWidth: 60, sortable: true},
                {field: 'name', title: this.msg('开户公司'), minWidth: 80, sortable: true},
                // {field: 'password', title: this.msg('结算密码'), minWidth: 120, sortable: true},
                // {field: 'word', title: this.msg('口令'), minWidth: 120, sortable: true},
                {field: 'paymentImg', title: this.msg('收款附件'), minWidth: 150, sortable: true,
                    slots: {
                        default: ({ row }) => {
                                let id = row.paymentImg
                                return id?[
                                    <el-image  style="width: 100px; height: 100px" 
                                        src={this.$kit.api.imgView+id} 
                                        preview-src-list={[this.$kit.api.imgView+id]}
                                        ></el-image>
                                ]: [id];
                            },
                    }
                },
                {field: 'createrName', title: this.msg('创建人'), minWidth: 80, sortable: true},
                {field: 'created', title: this.msg('创建时间'), minWidth:130, sortable: true}
            ],
            companys: [],
            dgTitle: '',
            dgVisible: false,
            curr: null,
        }
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
            return this.$store.state.isMinScreen;
            }
        },
        docHeight: {  //表格的高度
            get() {
                var height =  this.$store.state.docHeight;
                return height - 220;
            }
        },
        routeTab: {
            get(){
                try{
                    return this.$store.state.activeMenus[this.$route.path]
                }catch{
                    return null;
                }
            }
        }
    },
    methods: {
        list(){
            var param = this.$kit.rebuildQuery(this.query);

            this.$axios.post(this.$kit.api.company.list, param)
                .then((result) => {
                    if(result.status){
                        this.companys = result.data.list;
                        this.query.pageTotal = result.data.total;
                    }else{
                        this.$message(result.msg || this.msg('获取失败'));
                    }
                });
        },
        reset(){
            this.$kit.clearQuery(this.query);
        },
        //点击行，选中行
        checkRow({row, $event}){
            //如果点击checkbox 则不处理
            if($event.target.className.indexOf("vxe-checkbox--icon")== -1){
                var table =  this.$refs.dataTable;
                table.setCheckboxRow([row], !table.isCheckedByCheckboxRow(row))
            }
        },
        //分页数据发生改变，回调事件：info[0]: 每页显示的数量，info[1]: 起始页
        handlerPageChange(info){
            this.query.length = info[0];
            this.query.start = info[1];
            this.list();
        },
        doAdd(){
            this.curr = { 
                id:null,
                name: null,
                password:null,
                word:null,
                paymentImg:null,
            };

            this.dgTitle = this.msg("新增开户公司");
            this.dgVisible = true;
        },
        doEdit(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            if(selectes.length>1){
                this.$message(this.msg('只能编辑一条数据'));
                return;
            }

            this.$prompt('请输入<'+selectes[0].name+'>结算密码',this.msg('确认密码：'), {
                confirmButtonText: this.msg('确定'),
                cancelButtonText: this.msg('取消'),
                inputType: 'password',
            }).then(({ value }) => {

                this.$axios.post(this.$kit.api.wallet.checkCompanyPwd+"?companyId="+selectes[0].id+"&pwd="+value)
                .then((result) => {
                    if(result.status){

                        let company = selectes[0];
                        this.curr = { 
                            id:company.id,
                            name: company.name,
                            password:null,
                            word:null,
                            paymentImg:company.paymentImg,
                        };

                        this.dgTitle = this.msg("编辑开户公司");
                        this.dgVisible = true;

                    }else{
                        this.$message(result.msg || this.msg('结算密码不正确'));
                    }
                });

            }).catch(() => {
                console.log("取消操作");         
            })

        },
        doExport(){
            this.$refs.dataTable.openExport({ isPrint: false })
        },
        doDelete(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            if(selectes.length > 1){
                this.$message(this.msg('只能选中一条数据进行操作'));
                return;
            }

            this.$confirm('确定要删除《'+selectes[0].name+'》吗?', this.msg('提示'), {
                confirmButtonText: this.msg('确定'),
                cancelButtonText: this.msg('取消'),
                type: 'warning'
            }).then(() => {
                if(this.loginUser.username == 'admin'){
                    this.doDelete2();
                }else{
                    this.doDelete1();
                }
            }).catch((err) => {
            });
        },
        doDelete1(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            var _this = this;
            this.$prompt("请输入结算密码", this.msg('提示'), {
                    confirmButtonText: this.msg('确定'),
                    cancelButtonText: this.msg('取消'),
                    inputType: 'password',
                }).then(({ value }) => {
                    this.$axios.post(this.$kit.api.wallet.checkCompanyPwd+"?companyId="+selectes[0].id+"&pwd="+value)
                    .then((result) => {
                        if(result.status){
                            _this.$axios.post(_this.$kit.api.company.delete+"?id="+selectes[0].id)
                            .then((result) => {
                                _this.$message(result.msg || _this.msg('删除成功'));
                                _this.list(true);
                            });
                        }else{
                            this.$message(result.msg || this.msg('结算密码不正确'));
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });
                });
        },
        doDelete2(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            var _this = this;
             _this.$axios.post(_this.$kit.api.company.delete+"?id="+selectes[0].id)
                            .then((result) => {
                                _this.$message(result.msg || _this.msg('删除成功'));
                                _this.list(true);
                            });
        },
        closeEditDialog(type){  //编辑弹窗关闭后的回调事件
            if(type){
                this.list();
            }
            this.dgVisible = false;
        },
        openEditDg(){
            this.$nextTick(() => {
                this.$refs.editRef.init();
            });
        },
    },
}
</script>

<style lang="scss" scoped>

</style>
